export default "__VITE_ASSET__uq3LmEwk__"